import type { SVGProps } from 'react';

export const LogoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M18.1506 2.0452C18.8666 1.78386 19.6653 1.89053 20.288 2.32653C20.9106 2.76253 21.2813 3.47719 21.2813 4.23719V19.7638C21.2813 20.5238 20.9093 21.2385 20.2866 21.6745C19.8893 21.9531 19.42 22.0971 18.9466 22.0971C18.6786 22.0971 18.4093 22.0505 18.1506 21.9571L13.484 20.2598C12.5653 19.9265 11.948 19.0452 11.948 18.0678V15.0012H13.6146C15.2693 15.0012 16.6146 13.6558 16.6146 12.0012C16.6146 10.3465 15.2693 9.00118 13.6146 9.00118H11.948V5.93452C11.948 4.95719 12.5653 4.07586 13.484 3.74253L18.1506 2.0452ZM6.02931 10.9999H13.616L13.6133 10.9985C14.1653 10.9985 14.6133 11.4465 14.6133 11.9985C14.6133 12.5505 14.1653 12.9985 13.6133 12.9985H6.02798L8.98798 15.9585C9.37864 16.3492 9.37864 16.9825 8.98798 17.3732C8.79331 17.5692 8.53731 17.6665 8.28131 17.6665C8.02531 17.6665 7.76931 17.5678 7.57465 17.3732L2.90799 12.7065C2.51732 12.3158 2.51732 11.6825 2.90799 11.2919L7.57465 6.6252C7.96531 6.23453 8.59864 6.23453 8.98931 6.6252C9.37997 7.01586 9.37997 7.64919 8.98931 8.03986L6.02931 10.9999Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
